var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-diprotic-titration',{attrs:{"ka1":_vm.Ka1,"ka2":_vm.Ka2,"m-w-acid":_vm.MWAcid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }